var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('select2',{attrs:{"id":_vm.id,"name":_vm.name,"value":_vm.value,"multiple":false,"disabled":_vm.disabled,"required":_vm.required,"optionsData":_vm.optionsData,"placeholder":_vm.placeholder,"refreshFields":_vm.refreshFields,"focus":_vm.focus},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }